import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'currency'})
export class CurrencyPipe implements PipeTransform {
    transform(value: string): string {
        if(value === null) return '';
        return '$'+value.toString().replace(/[^0-9]/, '').replace(/,/g, '').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
    }
}



// WEBPACK FOOTER //
// ./src/app/currency.pipe.ts